// Add any hover over messages here
export const MsgHoverOverConfig = {
    Add_Notes_Disabled: "The Add Notes button is disabled because the notes section is currently enabled for adding new notes",
    Add_Notes_Enabled: "Add new notes.",
    Eqv_Search_Restriction: "The search is limited to equivalent drugs"
};
